import styled from 'styled-components'

import { WysiwygContainer } from '../../WysiwygRenderer/styled'
import Highlight from '../../Highlight'
import _Tag from '../../Tag'
import _TagAge from '../TagAge'
import Icon from '../../Icon'

export const Container = styled.div<{ backgroundColor: string }>`
  display: flex;
  flex-flow: column;
  max-width: 400rem;
  overflow: hidden;
  background: ${({ backgroundColor }) => backgroundColor};
  align-items: center;
  padding: 1rem;
  position: relative;
  height: 100%;
  transition: background-color 0.3s ease-in-out;
`

export const Background = styled(Icon)`
  position: absolute;
  top: 0;
  right: -60px;
  width: 140%;
  height: 83%;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent - 1};
  transform: rotate(180deg);
`

export const Tag = styled(_Tag)`
  text-align: center;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};

  margin-top: 2rem;
`

export const Title = styled(Highlight)`
  ${({ theme }) => theme.textStyles.text_bold_condensed_20}
  font-size: 2.2rem;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  margin-top: 4rem;

  @media (max-height: 800px) {
    margin-top: 1rem;
  }
`

export const StepNumber = styled.div`
  width: fit-content;
  ${({ theme }) => theme.textStyles.text_bold_32}
  color: ${({ theme }) => theme.colors.familyBurgundy};
  text-align: right;
  background-color: ${({ theme }) => theme.colors.familyYellow};
  border-radius: 50%;
  padding: 0.5rem 1.7rem;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  margin-top: 4rem;

  @media (max-height: 800px) {
    margin-top: 1rem;
  }
`

export const TagAge = styled(_TagAge)`
  margin: 2rem 0 0.8rem 0;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  & div {
    font-size: 1.4rem;
  }
  @media (max-height: 800px) {
    margin-top: 1rem;
  }
`

export const Text = styled(WysiwygContainer)`
  & p,
  span {
    ${({ theme }) => theme.textStyles.text_bold_22}
  }
  color: ${({ theme }) => theme.colors.familyBurgundy};
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  text-align: center;
  margin: 2rem 0 3rem 0;
  overflow-x: auto;
  overflow-y: scroll;
  max-height: 20rem;
  width: 100%;
  word-break: break-word;

  @media (max-height: 800px) {
    margin: 1rem 0 2rem 0;
  }
`

export const StepImage = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};

  @media (max-height: 800px) {
    width: 100px;
    height: 100px;

    & img {
      object-fit: contain !important;
    }
  }
`

export const BackgroundImage = styled.div<{ $children: boolean }>`
  position: fixed;
  top: 60%;
  left: 0;
  right: 0;
  bottom: ${({ $children }) => ($children ? '-8%' : '0')};
  z-index: ${({ theme }) => theme.zIndexes.background};
  opacity: 0.5;
`
